import { useState, Fragment, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchorderhistory,
  orderSelector,
  orderhistoryactions,
} from "@slices/Enquiry/Order/orderHistory";
import OrderStatus from "@pages/Enquiry/Order/OrderHistory/OrderStatus";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  ArrowUpSVG,
  ArrowDownSVG,
  Info_Order,
  LeftSVG,
  RightSVG,
  PreviousArrow,
} from "@icons";
import { useGetLoggedInUserInfo } from "@hooks";
import NoData from "@common/NoData";
import styled from "styled-components";
import "./CardTable.scss";
import LoadingOverlay from "@common/LoadingOverlay";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import { useTranslation } from "react-i18next";
import { useURLPagination } from "@hooks";

const PaginationContainer = styled.div`
  float: right;
  margin-top: -50px;
  padding: 0px 0px;
`;

const OrderTable = () => {
  const sessionId = useGetLoggedInUserInfo()?.sessionId;
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const history = useHistory();

  const [pageNumber, setPageNumber] = useState(1);
  const [filterPageNo, setFilterPageNo] = useState(1);
  const webSettings: any = useContext(WebSettingsContext);
  const { t, i18n } = useTranslation();
  const previousP = location?.state?.previousPage;
  // useURLPagination({
  //   page: [pageNumber, (val: string) => setPageNumber(+val)],
  //   filterPageNo: [filterPageNo, (val: string) => setFilterPageNo(+val)],
  // });

  const [currentOrderNumberSort, setCurrentOrderNumberSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_ASCENDING")}
      onClick={() => fetchASCsortorder("OrderNumber")}
    >
      <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
    </a>
  );
  const [currentCustomerSort, setCurrentCustomerSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("Customer")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentOrderDateSort, setCurrentOrderDateSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("OrderDate")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentStatusSort, setCurrentStatusSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("Status")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentOrderValueSort, setCurrentOrderValueSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("OrderValue")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentHandlerSort, setCurrentHandlerSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("Handler")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );
  const [currentYourOrderNumberSort, setCurrentYourOrderNumberSort] = useState(
    <a
      title={t("CON_CLICK_TO_SORT_DESCENDING")}
      onClick={() => fetchDESCsortorder("YourOrderNumber")}
    >
      <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
    </a>
  );

  const [sortcolumn, setSortColumn] = useState({
    SortColumn: "OrderNumber",
    orderBy: "DESC",
  });

  function fetchASCsortorder(type: string) {
    if (type == "OrderNumber") {
      setCurrentOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("OrderNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderNumber", orderBy: "ASC" });
    } else if (type == "Customer") {
      setCurrentCustomerSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("Customer")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Customer", orderBy: "ASC" });
    } else if (type == "OrderDate") {
      setCurrentOrderDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("OrderDate")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderDate", orderBy: "ASC" });
    } else if (type == "Status") {
      setCurrentStatusSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("Status")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Status", orderBy: "ASC" });
    } else if (type == "OrderValue") {
      setCurrentOrderValueSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("OrderValue")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderValue", orderBy: "ASC" });
    } else if (type == "Handler") {
      setCurrentHandlerSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("Handler")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Handler", orderBy: "ASC" });
    } else if (type == "YourOrderNumber") {
      setCurrentYourOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("YourOrderNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
      setSortColumn({ SortColumn: "YourOrderNumber", orderBy: "ASC" });
    }
  }

  function fetchDESCsortorder(type: string) {
    if (type == "OrderNumber") {
      setCurrentOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("OrderNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderNumber", orderBy: "DESC" });
    } else if (type == "Customer") {
      setCurrentCustomerSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("Customer")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Customer", orderBy: "DESC" });
    } else if (type == "OrderDate") {
      setCurrentOrderDateSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("OrderDate")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderDate", orderBy: "DESC" });
    } else if (type == "Status") {
      setCurrentStatusSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("Status")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Status", orderBy: "DESC" });
    } else if (type == "OrderValue") {
      setCurrentOrderValueSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("OrderValue")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "OrderValue", orderBy: "DESC" });
    } else if (type == "Handler") {
      setCurrentHandlerSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("Handler")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "Handler", orderBy: "DESC" });
    } else if (type == "YourOrderNumber") {
      setCurrentYourOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("YourOrderNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
      setSortColumn({ SortColumn: "YourOrderNumber", orderBy: "DESC" });
    }
  }

  const state = useSelector(orderSelector);
  const searchFilters = state?.orderHistory?.searchFilters;
  const loading = state?.orderHistory?.loading;
  // useURLPagination({
  //   page: [pageNumber, (val: string) => setPageNumber(+val)],
  //   filterPageNo: [filterPageNo, (val: string) => setFilterPageNo(+val)],
  //   Customer: [
  //     searchFilters.Customer,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ customerSearch: val })
  //       ),
  //   ],
  //   Status: [
  //     searchFilters.Status,
  //     (val: string) =>
  //       dispatch(orderhistoryactions.updateSearchFilter({ statusSearch: val })),
  //   ],
  //   Handler: [
  //     searchFilters.Handler,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ handlerSearch: val })
  //       ),
  //   ],
  //   Salesperson: [
  //     searchFilters.Salesperson,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ salesPersonSearch: val })
  //       ),
  //   ],
  //   OrderTextSearch: [
  //     searchFilters.OrderTextSearch,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ orderInputSearch: val })
  //       ),
  //   ],
  // });

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const page = params.get("page");
  //   if (page) setPageNumber(+page);
  // }, [location]);

  // useEffect(() => {
  //   const params = new URLSearchParams(history.location.search);
  //   const page = params.get("page");
  //   params.set("page", pageNumber.toString());
  //   if (!page) {
  //     history.replace({
  //       pathname: "",
  //       search: params.toString(),
  //     });
  //   } else {
  //     history.push({
  //       pathname: "",
  //       search: params.toString(),
  //     });
  //   }
  // }, [history, pageNumber]);
  // useURLPagination({
  //   page: [pageNumber, (val: string) => setPageNumber(+val)],
  //   filterPageNo: [filterPageNo, (val: string) => setFilterPageNo(+val)],
  //   Customer: [
  //     state.orderHistory.searchFilterSettings.customerSearch,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ customerSearch: val })
  //       ),
  //   ],
  //   Status: [
  //     state.orderHistory.searchFilterSettings.statusSearch,
  //     (val: string) =>
  //       dispatch(orderhistoryactions.updateSearchFilter({ statusSearch: val })),
  //   ],
  //   Handler: [
  //     state.orderHistory.searchFilterSettings.handlerSearch,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ handlerSearch: val })
  //       ),
  //   ],
  //   Salesperson: [
  //     state.orderHistory.searchFilterSettings.salesPersonSearch,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ salesPersonSearch: val })
  //       ),
  //   ],
  //   OrderTextSearch: [
  //     state.orderHistory.searchFilterSettings.orderInputSearch,
  //     (val: string) =>
  //       dispatch(
  //         orderhistoryactions.updateSearchFilter({ orderInputSearch: val })
  //       ),
  //   ],
  // });
  useURLPagination({
    page: [pageNumber, (val: string) => setPageNumber(+val)],
    filterPageNo: [filterPageNo, (val: string) => setFilterPageNo(+val)],
  });

  useEffect(() => {
    if (previousP !== undefined) {
      setPageNumber(previousP);
    }
  }, [previousP]);

  useEffect(() => {
    if (state?.orderHistory?.isFilterApply) {
      setSortColumn({ SortColumn: "OrderNumber", orderBy: "ASC" });
      setCurrentOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_DESCENDING")}
          onClick={() => fetchDESCsortorder("OrderNumber")}
        >
          <ArrowUpSVG className="primary-icon-2"></ArrowUpSVG>
        </a>
      );
    } else {
      setSortColumn({ SortColumn: "OrderNumber", orderBy: "DESC" });
      setCurrentOrderNumberSort(
        <a
          title={t("CON_CLICK_TO_SORT_ASCENDING")}
          onClick={() => fetchASCsortorder("OrderNumber")}
        >
          <ArrowDownSVG className="primary-icon-2"></ArrowDownSVG>
        </a>
      );
    }
  }, [state?.orderHistory?.isFilterApply, searchFilters]);

  useEffect(() => {
    return () => {
      dispatch(orderhistoryactions.clearSearchFilter());
    };
  }, []);

  useEffect(() => {
    if (sessionId) {
      dispatch(orderhistoryactions.intitalizeLoader());
      if (state?.orderHistory?.isFilterApply) {
        setPageNumber(1);
        dispatch(
          fetchorderhistory(
            sessionId,
            sortcolumn.orderBy,
            sortcolumn.SortColumn,
            filterPageNo,
            true,
            searchFilters.Customer,
            searchFilters.Status,
            searchFilters.Handler,
            searchFilters.Salesperson,
            searchFilters.OrderTextSearch
          )
        );
      } else {
        setFilterPageNo(1);
        dispatch(
          fetchorderhistory(
            sessionId,
            sortcolumn.orderBy,
            sortcolumn.SortColumn,
            pageNumber
          )
        );
      }
    }
  }, [sessionId, sortcolumn, pageNumber, filterPageNo]);

  const handleNextPage = () => {
    state?.orderHistory?.isFilterApply
      ? setFilterPageNo((prevstate) => prevstate + 1)
      : setPageNumber((prevstate) => prevstate + 1);
  };

  const handlePrevPage = () => {
    state?.orderHistory?.isFilterApply
      ? setFilterPageNo((prevstate) => prevstate - 1)
      : setPageNumber((prevstate) => prevstate - 1);
      /* to solve the issue of not changing url page number from 2 to 1 */
      if(pageNumber === 2) {
        localStorage.setItem("paginationString", 'page=1&filterPageNo=1');
      }
  };

  const handleFirstPage = () => {
    state?.orderHistory?.isFilterApply ? setFilterPageNo(1) : setPageNumber(1);
    /* to solve the issue of not changing url page number from 2 to 1 */
    localStorage.setItem("paginationString", 'page=1&filterPageNo=1');
  };

  //console.log(state?.orderHistory?.orders?.salesOrderBean?.filter((item: any) => item.shipmentTrackingDataAvailable == true));
  return (
    <Fragment>
      <PaginationContainer>
        {state?.orderHistory?.orders?.salesOrderBean?.length > 0 && (
          <div className="custom-pagination">
            <a
              onClick={handleFirstPage}
              title={t("CON_FIRST_PAGE")}
              className={`default ${
                pageNumber == 1 && filterPageNo == 1 ? "disable" : ""
              }`}
            >
              <PreviousArrow className="icon-color" />
            </a>
            <a
              onClick={handlePrevPage}
              title={t("CON_PREVIOUS_PAGE")}
              className={`default ${
                pageNumber == 1 && filterPageNo == 1 ? "disable" : "default"
              }`}
            >
              <LeftSVG className="icon-color" />
            </a>
            <a
              onClick={handleNextPage}
              title={t("CON_NEXT")}
              className={`default ${
                !state?.orderHistory?.orders?.moreRecords ? "disable" : ""
              }`}
            >
              <RightSVG className="icon-color" />
            </a>
          </div>
        )}
      </PaginationContainer>
      <div className="card-table">
        <div className="card-thead">
          <div className="row">
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> #{t("CON_ORDER")}</div>
                <div className="col-sort">{currentOrderNumberSort}</div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("COH_CUSTOMER")}</div>
                <div className="col-sort">{currentCustomerSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("CON_ORDER_DATE")}</div>
                <div className="col-sort">{currentOrderDateSort}</div>
              </div>
            </div>
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("CON_STATUS")}</div>
                <div className="col-sort">{currentStatusSort}</div>
              </div>
            </div>

            <div className="col">
              <div className="d-flex">
                <div className="col-title">{t("CON_ORDER_VALUE")}</div>
                <div className="col-sort">{currentOrderValueSort}</div>
              </div>
            </div>
            {webSettings?.showHandlerOrder && (
              <div className="col">
                <div className="d-flex">
                  <div className="col-title"> {t("CON_HANDLER")}</div>
                  <div className="col-sort">{currentHandlerSort}</div>
                </div>
              </div>
            )}
            <div className="col">
              <div className="d-flex">
                <div className="col-title"> {t("CON_YOUR_ORDER")}#</div>
                <div className="col-sort">{currentYourOrderNumberSort}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="card-tbody">
          {state?.orderHistory?.orders?.salesOrderBean?.length == 0 && (
            <NoData />
          )}
          {state?.orderHistory?.orders?.salesOrderBean?.map((items: any, i: number) => {
            return (
              <div className="row" key={i}>
                <div className="col">
                  <div className="flex-container">
                    <div className="label"># {t("CON_ORDER")}</div>
                    <div>
                      <Link
                        to={{
                          pathname: `/orderhistory/${items.orderNumber}`,
                          state: {
                            previousPageNo: pageNumber,
                          },
                        }}
                      >
                        {items.orderNumber}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="flex-container">
                    <div className="label">{t("COH_CUSTOMER")}</div>
                    <div>{items.customer}</div>
                  </div>
                </div>
                <div className="col">
                  <div className="flex-container">
                    <div className="label">{t("CON_ORDER_DATE")}</div>
                    <div>{items.orderDate}</div>
                  </div>
                </div>
                <div className="col">
                  <div className="flex-container">
                    <div className="label">{t("CON_STATUS")}</div>
                    <OrderStatus
                      orderstatus={items.status}
                      isOrderHeldFlag={items.isOrderHeldFlag}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="flex-container">
                    <div className="label">{t("CON_ORDER_VALUE")}</div>
                    <div>
                      {items.isOrderValueFlag && (
                        <Info_Order title={items.orderValue} />
                      )}
                    </div>
                    <div>{!items.isOrderValueFlag && items.orderValue}</div>
                  </div>
                </div>
                {webSettings?.showHandlerOrder && (
                  <div className="col order-value-position">
                    <div className="flex-container">
                      <div className="label">{t("CON_HANDLER")}</div>
                      <div>{items.handler}</div>
                    </div>
                  </div>
                )}
                <div className="col">
                  <div className="flex-container">
                    <div className="label">{t("CON_YOUR_ORDER")}#</div>
                    <div>{items.yourOrderNo}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <LoadingOverlay active={loading} />
    </Fragment>
  );
};

export default OrderTable;
